import { Socket } from 'socket.io-client'
import store from 'store2'
import { JWT_TOKEN_NAME } from '../constants/auth-key'
import { IMerchant } from '../types/merchant'
import { FACEBOOK_MESSAGE_EVENT } from '../constants/global'
import { IMessageItem } from '../resources/chats'
import dayjs from 'dayjs'

const facebookChatSubscribe = (
  socket: Socket,
  opts: {
    user: any
    merchant: any | IMerchant
    mutate?: () => void
    setIncommingMessage?: (msg: IMessageItem) => void
  },
) => {
  const jwtToken = store.get(JWT_TOKEN_NAME)
  const { user, merchant, mutate, setIncommingMessage } = opts
  if (!user) {
    return
  }
  socket.emit(FACEBOOK_MESSAGE_EVENT, {
    username: merchant.prefix,
    token: jwtToken,
  })
  socket.on(FACEBOOK_MESSAGE_EVENT, (msg: any) => {
    // console.log('any', msg)
    const { data } = msg
    mutate?.()

    const urls =
      data.attachments?.map((attachment: any) => ({
        image_data: {
          url: attachment?.payload?.url ?? '',
        },
      })) ?? []

    const attachments = {
      data: urls ?? [],
    }

    const incommingMessage: IMessageItem = {
      id: dayjs().unix().toString(),
      from: { id: data?.senderId ?? '' },
      message: data.message ?? '',
      attachments,
      created_time: new Date().toISOString(),
    }
    //console.log('incommingMessage socket', incommingMessage)
    setIncommingMessage?.(incommingMessage)
  })
}
export default facebookChatSubscribe
